import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { hasTopupOperatorPermission, isAdminLocalDev } from './adminAccess'

export { hasTopupOperatorPermission } from './adminAccess'

// The operator top-up surface (/admin/topup) accepts either the broad
// service-controlled admin role or the scoped "topup_operator" permission.
// The backend POST /admin/sparks/topup 403 is the real boundary — this just hides
// the route so non-operators never see it. Local dev bypasses, like ProtectedRoute.
//
// Reads app_metadata ONLY — user_metadata is client-editable and must never gate
// a mint affordance. Claims are baked into the JWT, so changes require a token
// refresh / re-login (the backend 403 remains authoritative until then).
//
export default function AdminTopupRoute() {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (isAdminLocalDev() || hasTopupOperatorPermission(user)) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
